import { isBooleanControl, rankWith, schemaTypeIs, uiTypeIs } from '@jsonforms/core'

export const textInputTester = rankWith(2, schemaTypeIs('string'))
export const booleanInputTester = rankWith(3, isBooleanControl)
export const verticalLayoutTester = rankWith(2, uiTypeIs('VerticalLayout'))
